(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advantages"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const marqueeContainer = document.querySelector('.advantages-marquee .marquee-container');
    const marqueeContent = document.querySelector('.advantages-marquee .marquee-content');
    
    if (marqueeContainer && marqueeContent) {
      const items = marqueeContent.querySelectorAll('.advantage-item');
      
      if (items.length > 0) {
        const containerWidth = marqueeContainer.offsetWidth;
        const singleItemWidth = Array.from(items).reduce((total, item) => {
          const rect = item.getBoundingClientRect();
          const style = window.getComputedStyle(item);
          const marginRight = parseFloat(style.marginRight);
          return total + rect.width + marginRight;
        }, 0);
        
        const cloneCount = Math.max(10, Math.ceil((containerWidth * 2) / singleItemWidth));
        for (let i = 0; i < cloneCount; i++) {
          items.forEach(item => {
            const clone = item.cloneNode(true);
            marqueeContent.appendChild(clone);
          });
        }
        
        marqueeContent.offsetWidth;
        
        const originalItemsWidth = singleItemWidth;
        
        let position = 0;
        const speed = 50;
        let lastTime = performance.now();
        let animationId = null;
        
        function animate(currentTime) {
          const deltaTime = (currentTime - lastTime) / 1000;
          lastTime = currentTime;
          
          position -= speed * deltaTime;
          if (position <= -originalItemsWidth) {
            position = 0;
          }
          marqueeContent.style.transform = `translateX(${position}px)`;
          animationId = requestAnimationFrame(animate);
        }
        
        animationId = requestAnimationFrame(animate);
        
        marqueeContainer.addEventListener('mouseenter', () => {
          if (animationId) {
            cancelAnimationFrame(animationId);
            animationId = null;
          }
        });
        
        marqueeContainer.addEventListener('mouseleave', () => {
          lastTime = performance.now();
          animationId = requestAnimationFrame(animate);
        });
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const quantityButtons = document.querySelectorAll('.cart-quantity-btn');
    
    quantityButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const key = this.dataset.key;
        const action = this.classList.contains('cart-quantity-increase') ? 'increase' : 'decrease';
        const input = document.querySelector(`.cart-quantity-input[data-key="${key}"]`);
        const quantityNumber = this.closest('.cart-item').querySelector('.cart-quantity-number');
        let quantity = parseInt(quantityNumber.textContent);
        
        if (action === 'increase') {
          quantity++;
        } else if (action === 'decrease' && quantity > 1) {
          quantity--;
        }
        
        if (input) {
          input.value = quantity;
        }
        quantityNumber.textContent = quantity;
        
        const updates = {};
        document.querySelectorAll('.cart-quantity-input').forEach(input => {
          updates[input.dataset.key] = parseInt(input.value);
        });
        
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ updates: updates })
        })
        .then(res => res.json())
        .then(cart => {
          window.location.reload();
        })
        .catch(error => {
          console.error('Error updating cart:', error);
        });
      });
    });
    
    const discountConfirmBtn = document.getElementById('discountConfirmBtn');
    const discountCodeInput = document.getElementById('discountCodeInput');
    
    if (discountConfirmBtn && discountCodeInput) {
      discountConfirmBtn.addEventListener('click', function() {
        const discountCode = discountCodeInput.value.trim();
        if (discountCode) {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ discount: discountCode })
          })
          .then(res => res.json())
            .then(cart => {
              window.location.reload();
            })
          .catch(error => {
            console.error('Error applying discount:', error);
            alert('Error applying discount code');
          });
        }
      });
      
      discountCodeInput.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') {
          discountConfirmBtn.click();
        }
      });
    }
    
    const discountRemoveBtn = document.getElementById('discountRemoveBtn');
    if (discountRemoveBtn) {
      discountRemoveBtn.addEventListener('click', function() {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ discount: '' })
        })
        .then(res => res.json())
        .then(cart => {
          window.location.reload();
        })
        .catch(error => {
          console.error('Error removing discount:', error);
          alert('Error removing discount code');
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["checkout"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const checkoutForm = document.getElementById('checkout-form');
    const sameAsShippingCheckbox = document.getElementById('same_as_shipping');
    const shippingToggle = document.getElementById('shipping-toggle');
    const notesToggle = document.getElementById('notes-toggle');
    const shippingOptions = document.getElementById('shipping-options');
    const orderNotesContainer = document.getElementById('order-notes-container');
    const shippingOptionElements = document.querySelectorAll('.shipping_option');
    const checkoutButton = document.getElementById('checkout-button');
    const checkoutPage = document.querySelector('.checkout-page');
    
    let selectedShippingMethod = '';
    let shippingFee = 0;
    
    const subtotal = parseInt(checkoutPage.dataset.subtotal) || 0;
    const tax = parseInt(checkoutPage.dataset.tax) || 0;
    const discount = parseInt(checkoutPage.dataset.discount) || 0;
    
    const updateTotal = () => {
      const total = subtotal + shippingFee + tax - discount;
      document.getElementById('total').textContent = formatMoney(total);
      document.getElementById('shipping-fee').textContent = formatMoney(shippingFee);
    };
    
    const formatMoney = (amount) => {
      return '$' + (amount / 100).toFixed(2);
    };
    
    const updatePhoneInputWidth = (containerId, textId) => {
      const textElement = document.getElementById(textId);
      const codeElement = document.getElementById(containerId);
      if (textElement && codeElement) {
        const width = textElement.offsetWidth;
        if (width > 0) {
          codeElement.style.flex = '0';
          codeElement.style.width = width + 'px';
        } else {
          codeElement.style.flex = '1';
          codeElement.style.width = '80px';
        }
      }
    };
    
    const handleShippingChange = (field, value) => {
      if (field === 'country') {
        const upperValue = value.toUpperCase().replace(/[^A-Z]/g, '').slice(0, 2);
        document.getElementById('shipping_' + field).value = upperValue;
      } else if (field === 'phoneCountryCode') {
        const digits = value.replace(/[^0-9]/g, '');
        let formattedValue = '';
        if (digits.length > 0) {
          formattedValue = '+' + digits.slice(0, 5);
        }
        document.getElementById('shipping_' + field).value = formattedValue;
        updatePhoneInputWidth('shipping_phoneCountryCode', 'shippingCountryCodeText');
      } else if (field === 'phoneNumber') {
        const digits = value.replace(/[^0-9]/g, '');
        document.getElementById('shipping_' + field).value = digits;
      }
    };
    
    const handleBillingChange = (field, value) => {
      if (field === 'country') {
        const upperValue = value.toUpperCase().replace(/[^A-Z]/g, '').slice(0, 2);
        document.getElementById('billing_' + field).value = upperValue;
      } else if (field === 'phoneCountryCode') {
        const digits = value.replace(/[^0-9]/g, '');
        let formattedValue = '';
        if (digits.length > 0) {
          formattedValue = '+' + digits.slice(0, 5);
        }
        document.getElementById('billing_' + field).value = formattedValue;
        updatePhoneInputWidth('billing_phoneCountryCode', 'billingCountryCodeText');
      } else if (field === 'phoneNumber') {
        const digits = value.replace(/[^0-9]/g, '');
        document.getElementById('billing_' + field).value = digits;
      }
    };
    
    const syncBillingAddress = () => {
      const isSame = sameAsShippingCheckbox.checked;
      const billingInputs = document.querySelectorAll('#billing-form input:not([type="checkbox"])');
      
      billingInputs.forEach(input => {
        if (isSame) {
          const fieldName = input.name.replace('billing_', '');
          const shippingInput = document.getElementById('shipping_' + fieldName);
          if (shippingInput) {
            input.value = shippingInput.value;
            input.disabled = true;
          }
        } else {
          input.disabled = false;
        }
      });
    };
    
    const toggleShippingOptions = () => {
      const isExpanded = shippingOptions.classList.contains('expanded');
      if (isExpanded) {
        shippingOptions.classList.remove('expanded');
        shippingOptions.classList.add('collapsed');
        shippingToggle.querySelector('.toggle_icon').textContent = '+';
      } else {
        shippingOptions.classList.remove('collapsed');
        shippingOptions.classList.add('expanded');
        shippingToggle.querySelector('.toggle_icon').textContent = '-';
      }
    };
    
    const toggleOrderNotes = () => {
      const isExpanded = orderNotesContainer.classList.contains('expanded');
      if (isExpanded) {
        orderNotesContainer.classList.remove('expanded');
        orderNotesContainer.classList.add('collapsed');
        notesToggle.querySelector('.toggle_icon').textContent = '+';
      } else {
        orderNotesContainer.classList.remove('collapsed');
        orderNotesContainer.classList.add('expanded');
        notesToggle.querySelector('.toggle_icon').textContent = '-';
      }
    };
    
    const selectShippingMethod = (method) => {
      selectedShippingMethod = method;
      shippingOptionElements.forEach(option => {
        if (option.dataset.method === method) {
          option.classList.add('selected');
        } else {
          option.classList.remove('selected');
        }
      });
      
      if (method === 'express') {
        shippingFee = 2999;
        document.getElementById('express-price').textContent = formatMoney(shippingFee);
      } else if (method === 'standard') {
        shippingFee = 0;
        document.getElementById('standard-price').textContent = 'FREE';
      }
      
      updateTotal();
    };
    
    const validateForm = () => {
      const requiredFields = [
        'shipping_fullName',
        'shipping_phoneNumber',
        'shipping_streetAddress',
        'shipping_city',
        'shipping_zipCode',
        'shipping_country'
      ];
      
      for (const fieldId of requiredFields) {
        const field = document.getElementById(fieldId);
        if (!field || !field.value.trim()) {
          alert('Please fill in all required shipping address fields');
          return false;
        }
      }
      
      if (!selectedShippingMethod) {
        alert('Please select a shipping method');
        return false;
      }
      
      const termsCheckbox = document.getElementById('terms_agreement');
      if (!termsCheckbox || !termsCheckbox.checked) {
        alert('Please agree to the Terms of Service and Privacy Policy');
        return false;
      }
      
      return true;
    };
    
    const handleSubmit = async (e) => {
      e.preventDefault();
      
      if (!validateForm()) {
        return;
      }
      
      checkoutButton.disabled = true;
      checkoutButton.textContent = 'Processing...';
      
      try {
        const formData = new FormData(checkoutForm);
        const shippingAddress = {
          full_name: formData.get('shipping_fullName'),
          phone: formData.get('shipping_phoneCountryCode') + ' ' + formData.get('shipping_phoneNumber'),
          street: formData.get('shipping_streetAddress'),
          city: formData.get('shipping_city'),
          state: formData.get('shipping_state'),
          postal_code: formData.get('shipping_zipCode'),
          country: formData.get('shipping_country')
        };
        
        const billingAddress = sameAsShippingCheckbox.checked ? shippingAddress : {
          full_name: formData.get('billing_fullName'),
          phone: formData.get('billing_phoneCountryCode') + ' ' + formData.get('billing_phoneNumber'),
          email: formData.get('billing_emailAddress'),
          street: formData.get('billing_street'),
          city: formData.get('billing_city'),
          state: formData.get('billing_state'),
          postal_code: formData.get('billing_zipCode'),
          country: formData.get('billing_country'),
          company: formData.get('billing_companyName')
        };
        
        console.log('Checkout Data:', { shippingAddress, billingAddress, shippingMethod: selectedShippingMethod });
        
        alert('Order placed successfully! Redirecting to payment...');
        
        window.location.href = '/checkout';
      } catch (error) {
        console.error('Checkout error:', error);
        alert('An error occurred. Please try again.');
        checkoutButton.disabled = false;
        checkoutButton.textContent = 'Place Order';
      }
    };
    
    sameAsShippingCheckbox.addEventListener('change', syncBillingAddress);
    shippingToggle.addEventListener('click', toggleShippingOptions);
    notesToggle.addEventListener('click', toggleOrderNotes);
    
    shippingOptionElements.forEach(option => {
      option.addEventListener('click', () => {
        selectShippingMethod(option.dataset.method);
      });
    });
    
    checkoutForm.addEventListener('submit', handleSubmit);
    
    const shippingInputs = document.querySelectorAll('#shipping_fullName, #shipping_phoneCountryCode, #shipping_phoneNumber, #shipping_streetAddress, #shipping_city, #shipping_zipCode, #shipping_state, #shipping_country');
    shippingInputs.forEach(input => {
      input.addEventListener('input', (e) => {
        const fieldName = e.target.name.replace('shipping_', '');
        handleShippingChange(fieldName, e.target.value);
      });
    });
    
    const billingInputs = document.querySelectorAll('#billing_fullName, #billing_phoneCountryCode, #billing_phoneNumber, #billing_street, #billing_city, #billing_zipCode, #billing_state, #billing_country');
    billingInputs.forEach(input => {
      input.addEventListener('input', (e) => {
        const fieldName = e.target.name.replace('billing_', '');
        handleBillingChange(fieldName, e.target.value);
      });
    });
    
    const allInputs = document.querySelectorAll('.form-input');
    allInputs.forEach(input => {
      const updateHasValue = () => {
        if (input.value.trim()) {
          input.classList.add('has_value');
        } else {
          input.classList.remove('has_value');
        }
      };
      
      input.addEventListener('input', updateHasValue);
      input.addEventListener('blur', updateHasValue);
      updateHasValue();
    });
    
    updateTotal();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["email-verification"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const verificationForm = document.getElementById('verification-form');
    const emailInput = document.getElementById('email');
    const continueButton = document.getElementById('continue-button');
    let isSubmitting = false;
    
    const updateHasValue = () => {
      if (emailInput.value.trim()) {
        emailInput.classList.add('has_value');
      } else {
        emailInput.classList.remove('has_value');
      }
    };
    
    emailInput.addEventListener('input', updateHasValue);
    emailInput.addEventListener('blur', updateHasValue);
    updateHasValue();
    
    verificationForm.addEventListener('submit', async function(e) {
      e.preventDefault();
      
      if (isSubmitting) {
        return;
      }
      
      const email = emailInput.value.trim();
      
      if (!email) {
        alert('Please enter your email address');
        return;
      }
      
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        alert('Please enter a valid email address');
        return;
      }
      
      isSubmitting = true;
      continueButton.disabled = true;
      continueButton.textContent = 'Sending...';
      
      try {
        const response = await fetch('/apps/jarre-bull/api/email/send-code', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ email: email })
        });
        
        const data = await response.json();
        
        if (data.success) {
          localStorage.setItem('verification_email', email);
          localStorage.setItem('verification_code_sent', Date.now().toString());
          
          window.location.href = '/pages/verify-code?email=' + encodeURIComponent(email);
        } else {
          alert(data.error || 'Failed to send verification code. Please try again.');
        }
      } catch (error) {
        console.error('Error sending verification code:', error);
        alert('Failed to send verification code. Please try again.');
      } finally {
        isSubmitting = false;
        continueButton.disabled = false;
        continueButton.textContent = 'CONTINUE';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const header = document.querySelector('.header');
    const navItems = document.querySelectorAll('.nav-item.dropdown');
    const megaPanels = document.querySelectorAll('.mega-panel');
    
    // 存储滚动位置的变量
    let savedScrollY = 0;
    
    navItems.forEach(item => {
      const navLink = item.querySelector('.nav-link');
      
      navLink.addEventListener('click', function(e) {
        e.preventDefault();
        
        const panelId = item.getAttribute('data-panel');
        const targetPanel = document.getElementById(panelId);
        const isActive = item.classList.contains('active');
        
        navItems.forEach(otherItem => {
          otherItem.classList.remove('active');
        });
        
        megaPanels.forEach(panel => {
          panel.classList.remove('active');
        });
        
        if (!isActive && targetPanel) {
          item.classList.add('active');
          targetPanel.classList.add('active');
        }
      });
    });
    
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.header-nav') && !e.target.closest('.header-contact')) {
        navItems.forEach(item => {
          item.classList.remove('active');
        });
        
        megaPanels.forEach(panel => {
          panel.classList.remove('active');
        });
      }
    });
    
    const menuToggle = document.getElementById('menuToggle');
    const mobileMenu = document.getElementById('mobileMenu');
    const mobileMenuClose = document.getElementById('mobileMenuClose');
    
    if (menuToggle && mobileMenu) {
      menuToggle.addEventListener('click', function() {
        savedScrollY = window.scrollY; // 保存当前滚动位置
        mobileMenu.classList.add('active');
        document.body.classList.add('mobile-menu-open');
        header.style.transform = 'translateY(0)';
      });
    }
    
    if (mobileMenuClose && mobileMenu) {
      mobileMenuClose.addEventListener('click', function() {
        mobileMenu.classList.remove('active');
        document.body.classList.remove('mobile-menu-open');
        // 恢复滚动位置
        setTimeout(() => {
          window.scrollTo(0, savedScrollY);
        }, 10); // 延迟执行以确保body类已被移除
      });
    }
    
    if (mobileMenu) {
      mobileMenu.addEventListener('click', function(e) {
        if (e.target === mobileMenu) {
          mobileMenu.classList.remove('active');
          document.body.classList.remove('mobile-menu-open');
          // 恢复滚动位置
          setTimeout(() => {
            window.scrollTo(0, savedScrollY);
          }, 10); // 延迟执行以确保body类已被移除
        }
      });
    }
    
    const mobileNavHeaders = document.querySelectorAll('.mobile-nav-header');
    
    mobileNavHeaders.forEach(navHeader => {
      navHeader.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const submenuId = this.getAttribute('data-submenu');
        const submenu = document.getElementById(submenuId);
        const isActive = this.classList.contains('active');
        
        if (isActive) {
          this.classList.remove('active');
          if (submenu) {
            submenu.classList.remove('active');
          }
        } else {
          mobileNavHeaders.forEach(otherHeader => {
            otherHeader.classList.remove('active');
            const otherSubmenuId = otherHeader.getAttribute('data-submenu');
            if (otherSubmenuId) {
              const otherSubmenu = document.getElementById(otherSubmenuId);
              if (otherSubmenu) {
                otherSubmenu.classList.remove('active');
              }
            }
          });
          
          this.classList.add('active');
          if (submenu) {
            submenu.classList.add('active');
          }
        }
      });
    });
  
    // 导航栏滚动效果
    let lastScrollTop = 0;
    let lastScrollLeft = 0;
    
    // 使用 requestAnimationFrame 来优化滚动性能
    let ticking = false;
    
    function updateHeaderPosition() {
      if (document.body.classList.contains('mobile-menu-open')) {
        return; // 打开移动菜单时，不处理 header 滚动
      }
      
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
      
      // 检查是否有下拉菜单或移动端菜单展开
      const hasActiveDropdown = document.querySelector('.nav-item.dropdown.active');
      const hasActiveMobileMenu = document.body.classList.contains('mobile-menu-open');
      const hasActiveSubmenu = document.querySelector('.mobile-submenu.active');
      
      // 垂直滚动逻辑：导航栏滚动效果
      if (scrollTop > lastScrollTop && scrollTop > 100 && !hasActiveDropdown && !hasActiveMobileMenu && !hasActiveSubmenu) {
        // 向下滚动且超过100px，隐藏导航栏（但前提是没有任何菜单展开）
        header.style.transform = 'translateY(-100%)';
      } else {
        // 向上滚动，或有任何菜单展开时，显示导航栏
        header.style.transform = 'translateY(0)';
      }
      
      // 水平滚动逻辑：让header跟随水平滚动（仅在窗口宽度768px到1300px之间时生效）
      // if (header && window.innerWidth > 768 && window.innerWidth <= 1300) {
      //   // 立即应用变换，无过渡效果
      //   header.style.transition = 'none';
        
      //   // 获取当前transform值（去除可能存在的translateX）
      //   const translateYMatch = header.style.transform.match(/translateY\([^)]*\)/);
      //   const currentTranslateY = translateYMatch ? translateYMatch[0] : '';
        
      //   // 应用垂直和水平变换
      //   header.style.transform = `${currentTranslateY} translateX(${-scrollLeft}px)`;
      // }
      
      // 触发自定义事件，传递滚动信息
      const horizontalScrollEvent = new CustomEvent('horizontalScroll', {
        detail: {
          scrollLeft: scrollLeft,
          scrollDirection: scrollLeft > lastScrollLeft ? 'right' : scrollLeft < lastScrollLeft ? 'left' : 'none',
          delta: Math.abs(scrollLeft - lastScrollLeft),
          scrollTop: scrollTop,
          verticalScrollDirection: scrollTop > lastScrollTop ? 'down' : scrollTop < lastScrollTop ? 'up' : 'none'
        }
      });
      
      document.dispatchEvent(horizontalScrollEvent);
      
      lastScrollTop = scrollTop;
      lastScrollLeft = scrollLeft;
      ticking = false;
    }
    
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(updateHeaderPosition);
        ticking = true;
      }
    });
    
    // 页面加载完成后立即初始化header位置
    updateHeaderPosition();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const heroVideoWrapper = document.getElementById('heroVideoWrapper');
    const videoModal = document.getElementById('videoModal');
    const modalOverlay = document.getElementById('modalOverlay');
    const modalClose = document.getElementById('modalClose');
    
    if (heroVideoWrapper && videoModal) {
      heroVideoWrapper.addEventListener('click', function() {
        videoModal.classList.add('active');
        document.body.style.overflow = 'hidden';
      });
      
      modalOverlay.addEventListener('click', function() {
        closeModal();
      });
      
      modalClose.addEventListener('click', function() {
        closeModal();
      });
      
      function closeModal() {
        videoModal.classList.remove('active');
        document.body.style.overflow = '';
      }
      
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && videoModal.classList.contains('active')) {
          closeModal();
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-detail-shopify"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const refundModal = document.getElementById('refund-modal');
    const refundButton = document.getElementById('refund-button');
    const downloadButton = document.getElementById('download-button');
    const modalCloseButton = document.getElementById('modal-close-button');
    
    if (refundButton) {
      refundButton.addEventListener('click', function() {
        refundModal.style.display = 'flex';
        document.body.style.overflow = 'hidden';
      });
    }
    
    if (modalCloseButton) {
      modalCloseButton.addEventListener('click', function() {
        refundModal.style.display = 'none';
        document.body.style.overflow = '';
      });
    }
    
    if (refundModal) {
      refundModal.addEventListener('click', function(e) {
        if (e.target === refundModal) {
          refundModal.style.display = 'none';
          document.body.style.overflow = '';
        }
      });
    }
    
    if (downloadButton) {
      downloadButton.addEventListener('click', function() {
        window.print();
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-detail"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const urlParams = new URLSearchParams(window.location.search);
    const orderNumber = urlParams.get('orderNumber');
    const paymentEmail = urlParams.get('paymentEmail');
    
    const orderResultLayout = document.getElementById('order-result-layout');
    const loading = document.getElementById('loading');
    const notFound = document.getElementById('not-found');
    const refundModal = document.getElementById('refund-modal');
    const refundButton = document.getElementById('refund-button');
    const downloadButton = document.getElementById('download-button');
    const modalCloseButton = document.getElementById('modal-close-button');
    
    if (!orderNumber) {
      window.location.href = '/pages/order';
      return;
    }
    
    loading.style.display = 'flex';
    
    const fetchOrderData = async () => {
      try {
        const token = localStorage.getItem('auth_token');
        const headers = {
          'Content-Type': 'application/json',
        };
        
        if (token) {
          headers['Authorization'] = `Bearer ${token}`;
        }
        
        const response = await fetch(`/apps/jarre-bull/api/orders/${orderNumber}`, {
          method: 'GET',
          headers: headers
        });
        
        const data = await response.json();
        
        if (data.success && data.data) {
          const orderInfo = data.data;
          
          const shippingAddress = orderInfo.addresses?.find((addr) => addr.type === 'shipping') || orderInfo.addresses?.[0];
          
          let formattedOrderTime = '';
          if (orderInfo.created_at) {
            try {
              const date = new Date(orderInfo.created_at);
              formattedOrderTime = date.toLocaleString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: false,
              }).replace(/\//g, '/');
            } catch (e) {
              formattedOrderTime = orderInfo.created_at;
            }
          }
          
          const progress = {
            confirmed: orderInfo.status === 'confirmed',
            paymentCompleted: orderInfo.payment_status === 'paid',
            preparing: orderInfo.shipping_status === 'processing' || orderInfo.shipping_status === 'preparing' || orderInfo.shipping_status === 'shipped',
            delivered: orderInfo.shipping_status === 'delivered' || !!orderInfo.delivered_at,
          };
          
          document.getElementById('order-number').textContent = orderInfo.order_number || orderNumber;
          document.getElementById('order-time').textContent = formattedOrderTime;
          document.getElementById('transaction-id').textContent = orderInfo.transaction_id || '';
          
          if (progress.confirmed) {
            document.getElementById('step-confirmed').classList.add('step-active');
          }
          if (progress.paymentCompleted) {
            document.getElementById('step-payment').classList.add('step-active');
            document.getElementById('divider-payment').classList.add('progress-step-divider-active');
          }
          if (progress.preparing) {
            document.getElementById('step-shipping').classList.add('step-active');
            document.getElementById('divider-shipping').classList.add('progress-step-divider-active');
          }
          if (progress.delivered) {
            document.getElementById('step-delivered').classList.add('step-active');
            document.getElementById('divider-delivered').classList.add('progress-step-divider-active');
          }
          
          if (shippingAddress) {
            document.getElementById('shipping-recipient').textContent = shippingAddress.full_name || '';
            document.getElementById('shipping-phone').textContent = shippingAddress.phone || '';
            document.getElementById('shipping-email').textContent = shippingAddress.email || orderInfo.customer_email || '';
            document.getElementById('shipping-address').textContent = `${shippingAddress.street || ''}, ${shippingAddress.city || ''} ${shippingAddress.state || ''} ${shippingAddress.postal_code || ''}, ${shippingAddress.country || ''}`.trim();
          }
          
          document.getElementById('tracking-no').textContent = orderInfo.tracking_number || '';
          document.getElementById('estimated-delivery').textContent = orderInfo.shipping_period ? `Expected delivery within ${orderInfo.shipping_period} business days` : '';
          
          const productList = document.getElementById('product-list');
          productList.innerHTML = '';
          
          let subtotal = 0;
          orderInfo.order_items?.forEach((item) => {
            const itemPrice = item.unit_price || 0;
            const itemTotal = item.total_price || (itemPrice * item.quantity);
            subtotal += itemTotal;
            
            const productItem = document.createElement('div');
            productItem.className = 'product-item-box';
            productItem.innerHTML = `
              <div class="item-info">
                <span class="item-name">${item.product_name || ''}</span>
                <span class="item-details">${item.color || ''} ×${item.quantity}</span>
              </div>
              <span class="item-price">€ ${(itemPrice).toFixed(2)}</span>
            `;
            productList.appendChild(productItem);
          });
          
          const shippingFee = orderInfo.shipping_fee || 0;
          const discount = orderInfo.discount_amount || 0;
          const total = orderInfo.total_amount || 0;
          
          document.getElementById('subtotal').textContent = `€ ${subtotal.toFixed(2)}`;
          document.getElementById('shipping-fee').textContent = `€ ${shippingFee.toFixed(2)}`;
          document.getElementById('discount').textContent = `-€ ${discount.toFixed(2)}`;
          document.getElementById('total').textContent = `€ ${total.toFixed(2)}`;
          
          loading.style.display = 'none';
          orderResultLayout.style.display = 'flex';
        } else {
          loading.style.display = 'none';
          notFound.style.display = 'flex';
        }
      } catch (error) {
        console.error('Error fetching order data:', error);
        loading.style.display = 'none';
        notFound.style.display = 'flex';
      }
    };
    
    fetchOrderData();
    
    refundButton.addEventListener('click', function() {
      refundModal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    });
    
    modalCloseButton.addEventListener('click', function() {
      refundModal.style.display = 'none';
      document.body.style.overflow = '';
    });
    
    refundModal.addEventListener('click', function(e) {
      if (e.target === refundModal) {
        refundModal.style.display = 'none';
        document.body.style.overflow = '';
      }
    });
    
    downloadButton.addEventListener('click', function() {
      alert('PDF download feature will be implemented with backend integration.');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-tracking"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const orderNumberInput = document.getElementById('order_number');
    const customerEmailInput = document.getElementById('customer_email');
    
    const urlParams = new URLSearchParams(window.location.search);
    const urlOrderNumber = urlParams.get('orderNumber');
    const urlPaymentEmail = urlParams.get('paymentEmail');
    
    if (urlOrderNumber) {
      orderNumberInput.value = urlOrderNumber;
      orderNumberInput.classList.add('has_value');
      
      if (urlPaymentEmail) {
        customerEmailInput.value = urlPaymentEmail;
        customerEmailInput.classList.add('has_value');
      }
    }
    
    const updateHasValue = (input) => {
      if (input.value.trim()) {
        input.classList.add('has_value');
      } else {
        input.classList.remove('has_value');
      }
    };
    
    orderNumberInput.addEventListener('input', () => updateHasValue(orderNumberInput));
    orderNumberInput.addEventListener('blur', () => updateHasValue(orderNumberInput));
    customerEmailInput.addEventListener('input', () => updateHasValue(customerEmailInput));
    customerEmailInput.addEventListener('blur', () => updateHasValue(customerEmailInput));
    
    updateHasValue(orderNumberInput);
    updateHasValue(customerEmailInput);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-quick-select-grid"] && !Shopify.designMode) return;
  try {
    
  console.log('Product Quick Select Grid JS loaded!');
  
  document.addEventListener('DOMContentLoaded', function() {
    console.log('DOM Content Loaded!');
    
    const expandButtons = document.querySelectorAll('.expand-btn');
    console.log('Found expand buttons:', expandButtons.length);
    
    expandButtons.forEach(function(button, index) {
      console.log('Adding click listener to button', index);
      button.addEventListener('click', function(e) {
        console.log('Expand button clicked!', e, this);
        const card = this.closest('.product-card');
        const skuList = card.querySelector('.product-sku-list');
        console.log('Card:', card, 'SKU List:', skuList);
        skuList.style.display = 'flex';
      });
    });
    
    const closeButtons = document.querySelectorAll('.close-btn');
    console.log('Found close buttons:', closeButtons.length);
    
    closeButtons.forEach(function(button, index) {
      console.log('Adding click listener to close button', index);
      button.addEventListener('click', function(e) {
        console.log('Close button clicked!', e, this);
        const card = this.closest('.product-card');
        const skuList = card.querySelector('.product-sku-list');
        console.log('Card:', card, 'SKU List:', skuList);
        skuList.style.display = 'none';
      });
    });
    
    const skuItems = document.querySelectorAll('.sku-item');
    console.log('Found SKU items:', skuItems.length);
    
    skuItems.forEach(function(item, index) {
      console.log('Adding click listener to SKU item', index);
      item.addEventListener('click', function(e) {
        console.log('SKU item clicked!', e, this);
        const variantId = this.getAttribute('data-variant-id');
        console.log('Variant ID:', variantId);
        
        if (!variantId) {
          console.error('Variant ID is missing!');
          alert('Error: Variant ID is missing');
          return;
        }
        
        // Get product handle
        const productCard = this.closest('.product-card');
        const productHandle = productCard.getAttribute('data-product-handle');
        
        if (!productHandle) {
          console.error('Product handle is missing!');
          alert('Error: Product handle is missing');
          return;
        }
        
        // Get material and color from data attributes
        const material = this.getAttribute('data-material') || '';
        const color = this.getAttribute('data-color') || '';
        const variantTitle = this.getAttribute('data-variant-title') || '';
        
        console.log('Variant title:', variantTitle);
        console.log('Material from data attribute:', material);
        console.log('Color from data attribute:', color);
        
        // Build redirect URL with variant, material, and color parameters
        let productUrl = `/products/${productHandle}?variant=${variantId}`;
        
        if (material) {
          productUrl += `&material=${encodeURIComponent(material)}`;
        }
        
        if (color) {
          productUrl += `&color=${encodeURIComponent(color)}`;
        }
        
        console.log('Redirecting to:', productUrl);
        
        // Execute redirect
        window.location.href = productUrl;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-specs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const specsItems = document.querySelectorAll('.specs-item');
    
    specsItems.forEach(item => {
      const title = item.querySelector('.specs-title');
      
      title.addEventListener('click', function() {
        item.classList.toggle('active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // 货币格式化函数
    function formatMoney(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      let value = '';
      const placeholderRegex = new RegExp('\\{\\{\\s*(\\w+)\\s*\\}\\}');
      const defaultFormat = String('$' + '{' + '{amount}' + '}');
      const formatString = format || defaultFormat;
      
      function defaultOption(opt, def) {
        return (typeof opt === 'undefined' ? def : opt);
      }
      
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');
        
        if (isNaN(number) || number === null) {
          return 0;
        }
        
        number = (number / 100).toFixed(precision);
        const parts = number.split('.');
        const dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
        const cents = parts[1] ? decimal + parts[1] : '';
        return dollars + cents;
      }
      
      const match = formatString.match(placeholderRegex);
      if (match) {
        switch (match[1]) {
          case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
          case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
          case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
          case 'amount_with_space_separator':
            value = formatWithDelimiters(cents, 2, ' ', ',');
            break;
          case 'amount_no_decimals_with_space_separator':
            value = formatWithDelimiters(cents, 0, ' ', ',');
            break;
        }
      }
      
      return formatString.replace(placeholderRegex, value);
    }
    
    // 声明全局变量
    let selectedMaterial = '';
    let selectedColor = '';
    
    // 从DOM中获取变体数据
    function getVariantData() {
      const variantElements = document.querySelectorAll('#variant-data .variant-info');
      const variants = [];
      
      variantElements.forEach(element => {
        variants.push({
          id: element.dataset.id,
          price: parseInt(element.dataset.price),
          compare_at_price: parseInt(element.dataset['compareAtPrice']),
          options: [element.dataset.option1, element.dataset.option2, element.dataset.option3],
          available: element.dataset.available === 'true'
        });
      });
      
      return variants;
    }
    
    // 获取所有变体信息
    const variantsData = getVariantData();
    
    // 获取 URL 参数的函数
    function getUrlParam(name) {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(name);
    }
    
    // 缩略图点击功能
    const thumbnails = document.querySelectorAll('.thumbnail-item');
    const mainImage = document.getElementById('main-product-image');
    const variantInput = document.querySelector('input[name="id"]');
    const priceElement = document.querySelector('.current-price');
    
    // 变体按钮功能
    const materialBtns = document.querySelectorAll('.product-material-variants .variant-btn');
    const colorOptions = document.querySelectorAll('.product-color-variants .color-option');
    
    console.log('=== 元素选择调试信息 ===');
    console.log('找到材质按钮:', materialBtns.length);
    console.log('找到颜色选项:', colorOptions.length);
    console.log('找到变体输入框:', !!variantInput);
    console.log('找到价格元素:', !!priceElement);
    console.log('================================');
    
    // 默认初始化函数
    function initializeDefaultVariant() {
      if (materialBtns.length > 0) {
        selectedMaterial = materialBtns[0].dataset.variant;
        console.log('初始化材质:', selectedMaterial);
      }
      
      // 先过滤颜色选项
      filterColorOptionsByMaterial(selectedMaterial);
      
      // 再更新变体和图片
      if (colorOptions.length > 0) {
        const firstVisibleColor = document.querySelector('.product-color-variants .color-option[style*="display: flex"]');
        if (firstVisibleColor) {
          selectedColor = firstVisibleColor.dataset.variant;
          console.log('初始化颜色:', selectedColor);
        }
      }
      
      // 调用 updateVariant 来触发完整的更新
      updateVariant();
    }
    
    // 检查 URL 中的参数
    const urlVariantId = getUrlParam('variant');
    const urlMaterial = getUrlParam('material');
    const urlColor = getUrlParam('color');
    
    console.log('URL 参数:');
    console.log('  variant:', urlVariantId);
    console.log('  material:', urlMaterial);
    console.log('  color:', urlColor);
    
    // 确保 DOM 完全加载后再执行，添加延迟以确保材质按钮已渲染
    setTimeout(() => {
      console.log('等待 DOM 加载完成后处理 URL 参数');
      
      // 重新获取材质按钮和颜色选项，确保它们已加载
      const updatedMaterialBtns = document.querySelectorAll('.product-material-variants .variant-btn');
      const updatedColorOptions = document.querySelectorAll('.product-color-variants .color-option');
      
      console.log('更新后的元素数量:');
      console.log('  材质按钮:', updatedMaterialBtns.length);
      console.log('  颜色选项:', updatedColorOptions.length);
      
      // 显示所有材质按钮的 data-variant 值，用于调试
      console.log('材质按钮数据:');
      updatedMaterialBtns.forEach((btn, index) => {
        console.log(`  ${index}: ${btn.dataset.variant}`);
      });
      
      // 如果 URL 中有材质和颜色参数，按顺序处理
      if (urlMaterial && urlColor) {
        console.log('开始处理 URL 材质和颜色参数');
        
        // 尝试两种匹配方式：先按材质匹配，再尝试按颜色匹配
        let matchingMaterialBtn = null;
        
        // 方式 1: 按材质参数匹配材质按钮
        matchingMaterialBtn = Array.from(updatedMaterialBtns).find(btn => {
          return btn.dataset.variant.toLowerCase() === urlMaterial.toLowerCase();
        });
        
        // 方式 2: 如果方式 1 失败，尝试按颜色参数匹配材质按钮
        if (!matchingMaterialBtn) {
          console.log('尝试按颜色参数匹配材质按钮');
          matchingMaterialBtn = Array.from(updatedMaterialBtns).find(btn => {
            return btn.dataset.variant.toLowerCase() === urlColor.toLowerCase();
          });
        }
        
        if (matchingMaterialBtn) {
          console.log('找到匹配的材质按钮:', matchingMaterialBtn);
          
          // 模拟点击材质按钮
          matchingMaterialBtn.click();
          
          // 等待材质选择完成（包括颜色选项过滤）
          setTimeout(() => {
            console.log('材质按钮点击完成，开始查找并点击颜色按钮');
            
            // 重新获取颜色选项，确保它们已更新
            const latestColorOptions = document.querySelectorAll('.product-color-variants .color-option');
            
            // 显示所有可见颜色选项的 data-variant 值，用于调试
            console.log('可见颜色选项数据:');
            latestColorOptions.forEach((option, index) => {
              if (option.style.display !== 'none') {
                console.log(`  ${index}: ${option.dataset.variant} (材质: ${option.dataset.material})`);
              }
            });
            
            // 尝试两种匹配方式：先按颜色参数匹配，再尝试按材质参数匹配
            let matchingColorOption = null;
            
            // 方式 1: 按颜色参数匹配颜色选项
            matchingColorOption = Array.from(latestColorOptions).find(option => {
              return option.style.display !== 'none' && 
                     option.dataset.variant.toLowerCase() === urlColor.toLowerCase();
            });
            
            // 方式 2: 如果方式 1 失败，尝试按材质参数匹配颜色选项
            if (!matchingColorOption) {
              console.log('尝试按材质参数匹配颜色选项');
              matchingColorOption = Array.from(latestColorOptions).find(option => {
                return option.style.display !== 'none' && 
                       option.dataset.variant.toLowerCase() === urlMaterial.toLowerCase();
              });
            }
            
            if (matchingColorOption) {
              console.log('找到匹配的颜色选项:', matchingColorOption);
              
              // 模拟点击颜色按钮
              matchingColorOption.click();
              
              // 等待颜色选择完成后，确保变体输入框的值正确
              setTimeout(() => {
                if (urlVariantId && variantInput) {
                  variantInput.value = urlVariantId;
                  console.log('更新变体输入框值:', urlVariantId);
                }
              }, 200);
            } else {
              console.log('未找到匹配的颜色选项');
              initializeDefaultVariant();
            }
          }, 300);
        } else {
          console.log('未找到匹配的材质按钮');
          console.log('期望的材质值:', urlMaterial);
          console.log('尝试使用颜色值作为材质:', urlColor);
          initializeDefaultVariant();
        }
      } else if (urlVariantId) {
        // 如果只有变体参数，尝试通过变体 ID 查找匹配的选项
        console.log('开始处理 URL 变体参数:', urlVariantId);
        
        // 查找匹配的颜色选项（包含变体 ID）
        const matchingColorOption = Array.from(updatedColorOptions).find(option => {
          return option.dataset.variantId === urlVariantId;
        });
        
        if (matchingColorOption) {
          console.log('找到匹配的颜色选项:', matchingColorOption);
          
          // 获取对应的材质
          const materialFromVariant = matchingColorOption.dataset.material;
          
          console.log('从变体中获取的材质:', materialFromVariant);
          
          // 找到对应的材质按钮
          const matchingMaterialBtn = Array.from(updatedMaterialBtns).find(btn => {
            return btn.dataset.variant.toLowerCase() === materialFromVariant.toLowerCase();
          });
          
          if (matchingMaterialBtn) {
            console.log('找到匹配的材质按钮:', matchingMaterialBtn);
            
            // 模拟点击材质按钮
            matchingMaterialBtn.click();
            
            // 等待材质选择完成
            setTimeout(() => {
              console.log('材质按钮点击完成，开始点击颜色按钮');
              
              // 再次查找匹配的颜色选项
              const latestColorOptions = document.querySelectorAll('.product-color-variants .color-option');
              const colorOptionToSelect = Array.from(latestColorOptions).find(option => {
                return option.style.display !== 'none' && 
                       option.dataset.variantId === urlVariantId;
              });
              
              if (colorOptionToSelect) {
                console.log('选择对应的颜色选项:', colorOptionToSelect);
                colorOptionToSelect.click();
              } else {
                console.log('未找到可见的匹配颜色选项');
                initializeDefaultVariant();
              }
            }, 300);
          } else {
            console.log('未找到匹配的材质按钮');
            console.log('期望的材质值:', materialFromVariant);
            initializeDefaultVariant();
          }
        } else {
          console.log('未找到匹配的颜色选项');
          initializeDefaultVariant();
        }
      } else {
        console.log('URL 中无相关参数，使用默认初始化');
        initializeDefaultVariant();
      }
    }, 500); // 添加延迟，确保 DOM 完全加载
    
    // 缩略图点击功能
    thumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', function() {
        const thumbnailImage = this.querySelector('img');
        if (thumbnailImage) {
          let imageUrl = thumbnailImage.src;
          if (imageUrl.includes('/width:80')) {
            imageUrl = imageUrl.replace('/width:80', '/width:1200');
          } else if (imageUrl.includes('/width:200')) {
            imageUrl = imageUrl.replace('/width:200', '/width:1200');
          }
          mainImage.src = imageUrl;
          mainImage.alt = thumbnailImage.alt;
        }
        
        // 从缩略图获取变体ID并更新表单（仅单个产品）
        const variantId = this.dataset.variantId;
        if (variantId && variantInput) {
          variantInput.value = variantId;
        }
        
        // 更新缩略图状态
        thumbnails.forEach(t => t.classList.remove('active'));
        this.classList.add('active');
      });
    });
    
    // 模式切换功能
    const modeBtns = document.querySelectorAll('.mode-btn');
    const quantityInput = document.getElementById('product-quantity');
    const basePrice = parseFloat(priceElement.dataset.basePrice);
    const moneyFormat = priceElement.dataset.moneyFormat;
    const thumbnailImages = document.querySelector('.thumbnail-images');
    const singleThumbnails = document.querySelectorAll('.thumbnail-single');
    const duoThumbnails = document.querySelectorAll('.thumbnail-duo');
    
    modeBtns.forEach(btn => {
      btn.addEventListener('click', function() {
        modeBtns.forEach(b => b.classList.remove('active'));
        this.classList.add('active');
        
        // 更新数量
        const duoTip = document.querySelector('.duo-true-tip');
        if (this.textContent.includes('DUO')) {
          quantityInput.value = '2';
          if (duoTip) {
            duoTip.style.display = 'block';
          }
        } else {
          quantityInput.value = '1';
          if (duoTip) {
            duoTip.style.display = 'none';
          }
        }
        
        // 调用 updateVariant 来处理价格、图片和其他更新
        updateVariant();
      });
    });
    
    // 根据选中的材质过滤颜色选项
    function filterColorOptionsByMaterial(material) {
      // 获取所有颜色选项
      const allColorOptions = document.querySelectorAll('.product-color-variants .color-option');
      
      console.log('开始过滤颜色选项，选中材质:', material);
      
      // 跟踪已显示的颜色以避免重复（同一个颜色可能对应多个材质）
      const displayedColors = new Set();
      
      // 根据材质显示/隐藏颜色选项
      allColorOptions.forEach(option => {
        const optionMaterial = option.dataset.material;
        const optionColor = option.dataset.variant;
        const shouldShow = !material || optionMaterial.toLowerCase() === material.toLowerCase();
        
        // 只显示匹配材质且未显示过的颜色
        if (shouldShow && !displayedColors.has(optionColor)) {
          option.style.display = 'flex';
          displayedColors.add(optionColor);
          console.log('显示颜色选项:', optionColor, '材质:', optionMaterial);
        } else {
          option.style.display = 'none';
          console.log('隐藏颜色选项:', optionColor, '材质:', optionMaterial, '原因:', shouldShow ? '颜色已显示' : '材质不匹配');
        }
      });
      
      // 选择第一个可见的颜色选项
      const firstVisibleColor = document.querySelector('.product-color-variants .color-option[style*="display: flex"]');
      if (firstVisibleColor) {
        selectedColor = firstVisibleColor.dataset.variant;
        // 更新激活状态
        allColorOptions.forEach(o => o.classList.remove('active'));
        firstVisibleColor.classList.add('active');
        console.log('选择第一个可用颜色:', selectedColor);
      } else {
        selectedColor = null;
        console.log('当前材质没有可用颜色');
      }
    }
    
    // 更新缩略图可见性
    function updateThumbnailVisibility() {
      const isDuoMode = document.querySelector('.mode-btn.active')?.textContent.includes('DUO');
      const selectedColorSafe = selectedColor.replace(/-/g, '_').replace(/ /g, '_');
      
      if (isDuoMode) {
        // DUO模式：更新DUO缩略图可见性，隐藏单个产品缩略图
        const duoThumbnails = document.querySelectorAll('.thumbnail-duo');
        duoThumbnails.forEach(t => {
          const material = t.dataset.material.toLowerCase();
          const color = t.dataset.colorSafe ? t.dataset.colorSafe.toLowerCase() : t.dataset.color.toLowerCase().replace(/-/g, '_').replace(/ /g, '_');
          const shouldShow = material === selectedMaterial.toLowerCase() && color === selectedColorSafe.toLowerCase();
          t.style.display = shouldShow ? 'block' : 'none';
        });
        
        // 隐藏所有单个产品缩略图
        const singleThumbnails = document.querySelectorAll('.thumbnail-single');
        singleThumbnails.forEach(t => {
          t.style.display = 'none';
        });
      } else {
        // SOLO模式：更新单个产品缩略图可见性，隐藏DUO缩略图
        const singleThumbnails = document.querySelectorAll('.thumbnail-single');
        singleThumbnails.forEach(t => {
          const material = t.dataset.material.toLowerCase();
          const color = t.dataset.color.toLowerCase();
          const shouldShow = material === selectedMaterial.toLowerCase() && color === selectedColor.toLowerCase();
          t.style.display = shouldShow ? 'block' : 'none';
        });
        
        // 隐藏所有DUO缩略图
        const duoThumbnails = document.querySelectorAll('.thumbnail-duo');
        duoThumbnails.forEach(t => {
          t.style.display = 'none';
        });
      }
    }
    
    // 根据可见缩略图数量决定是否显示缩略图列表
    function updateThumbnailListVisibility() {
      const isDuoMode = document.querySelector('.mode-btn.active')?.textContent.includes('DUO');
      
      if (isDuoMode) {
        const duoThumbnails = document.querySelectorAll('.thumbnail-duo');
        const visibleCount = Array.from(duoThumbnails).filter(t => t.style.display !== 'none').length;
        if (thumbnailImages) {
          thumbnailImages.style.display = visibleCount > 1 ? 'flex' : 'none';
        }
      } else {
        const singleThumbnails = document.querySelectorAll('.thumbnail-single');
        const visibleCount = Array.from(singleThumbnails).filter(t => t.style.display !== 'none').length;
        if (thumbnailImages) {
          thumbnailImages.style.display = visibleCount > 1 ? 'flex' : 'none';
        }
      }
    }
    
    // 更新变体和价格
    function updateVariant() {
      console.log('=== 开始更新变体 ===');
      console.log('当前选择的材质:', selectedMaterial);
      console.log('当前选择的颜色:', selectedColor);
      
      // 检查当前是否是DUO模式
      const isDuoMode = document.querySelector('.mode-btn.active')?.textContent.includes('DUO');
      
      // 先更新缩略图可见性
      updateThumbnailVisibility();
      
      // 再根据可见缩略图数量决定是否显示列表
      updateThumbnailListVisibility();
      
      if (isDuoMode) {
        // DUO模式：显示对应的DUO套装图片
        const duoThumbnails = document.querySelectorAll('.thumbnail-duo');
        const selectedColorSafe = selectedColor.replace(/-/g, '_').replace(/ /g, '_');
        const matchingDuo = Array.from(duoThumbnails).find(t => {
          const material = t.dataset.material.toLowerCase();
          const color = t.dataset.colorSafe ? t.dataset.colorSafe.toLowerCase() : t.dataset.color.toLowerCase().replace(/-/g, '_').replace(/ /g, '_');
          return material === selectedMaterial.toLowerCase() && color === selectedColorSafe.toLowerCase();
        });
        
        if (matchingDuo) {
          const duoImage = matchingDuo.querySelector('img');
          if (duoImage) {
            mainImage.src = duoImage.src.replace('/width:80', '/width:1200');
            mainImage.alt = duoImage.alt;
          }
        }
      } else {
        // SOLO模式：显示对应的单个产品图片
        const singleThumbnails = document.querySelectorAll('.thumbnail-single');
        const matchingSingle = Array.from(singleThumbnails).find(t => {
          const material = t.dataset.material.toLowerCase();
          const color = t.dataset.color.toLowerCase();
          return material === selectedMaterial.toLowerCase() && color === selectedColor.toLowerCase();
        });
        
        if (matchingSingle) {
          matchingSingle.click();
        }
      }
      
      // 根据当前模式查找对应的价格
      let variantPrice = null;
      let variantId = null;
      
      if (isDuoMode) {
        // DUO模式：查找DUO套装缩略图的价格
        const matchingDuo = Array.from(duoThumbnails).find(t => {
          const material = t.dataset.material.toLowerCase();
          const color = t.dataset.colorSafe ? t.dataset.colorSafe.toLowerCase() : t.dataset.color.toLowerCase().replace(/-/g, '_').replace(/ /g, '_');
          const selectedColorSafe = selectedColor.replace(/-/g, '_').replace(/ /g, '_');
          return material === selectedMaterial.toLowerCase() && color === selectedColorSafe.toLowerCase();
        });
        
        if (matchingDuo) {
          variantPrice = matchingDuo.dataset.price;
          // 对于DUO模式，我们仍使用单个产品的变体ID，但价格翻倍
          const matchingSingle = Array.from(singleThumbnails).find(t => {
            const material = t.dataset.material.toLowerCase();
            const color = t.dataset.color.toLowerCase();
            return material === selectedMaterial.toLowerCase() && color === selectedColor.toLowerCase();
          });
          if (matchingSingle) {
            variantId = matchingSingle.dataset.variantId;
          }
        }
      } else {
        // SOLO模式：查找当前活动的缩略图价格
        const activeThumbnail = document.querySelector('.thumbnail-single.active[data-material="' + selectedMaterial + '"][data-color="' + selectedColor + '"]');
        if (activeThumbnail) {
          variantPrice = activeThumbnail.dataset.price;
          variantId = activeThumbnail.dataset.variantId;
        }
      }
      
      // 更新价格显示
      if (variantPrice && priceElement) {
        // 计算最终价格（考虑DUO模式）
        let finalPrice = parseInt(variantPrice);
        
        // 更新价格显示
        const amountElement = priceElement.querySelector('.amount');
        if (amountElement) {
          const formatted = formatMoney(finalPrice, priceElement.dataset.moneyFormat);
          // Extract only the numeric amount part by removing currency symbols
          const amountValue = formatted.replace(/[^\d.,\s]/g, '').trim();
          amountElement.textContent = amountValue;
        }
        
        // 更新隐藏的变体ID输入框
        if (variantInput && variantId) {
          variantInput.value = variantId;
        }
      }
      
      console.log('=== 更新变体结束 ===');
    }
    
    // 初始化选择已在 URL 参数处理逻辑中完成
    
    // 颜色选择器点击处理
    colorOptions.forEach(option => {
      option.addEventListener('click', function() {
        selectedColor = this.dataset.variant;
        
        // 更新颜色选项
        colorOptions.forEach(o => o.classList.remove('active'));
        this.classList.add('active');
        
        // 更新变体和价格
        updateVariant();
      });
    });
    
    // 材质按钮点击处理
    materialBtns.forEach(btn => {
      btn.addEventListener('click', function() {
        selectedMaterial = this.dataset.variant;
        
        // 更新材质按钮
        materialBtns.forEach(b => b.classList.remove('active'));
        this.classList.add('active');
        
        // 根据选中的材质过滤颜色选项
        filterColorOptionsByMaterial(selectedMaterial);
        
        // 更新变体和价格
        updateVariant();
      });
    });
    
    // 初始化
    updateVariant();
    
    // 添加到购物车按钮点击处理
    const addToCartBtn = document.querySelector('.add-to-cart-btn');
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', async function() {
        const variantId = variantInput ? variantInput.value : null;
        const quantity = parseInt(document.getElementById('product-quantity').value) || 1;
        
        if (!variantId) {
          alert('Please select a variant');
          return;
        }
        
        try {
          this.disabled = true;
          this.textContent = 'Adding...';
          
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: variantId,
              quantity: quantity
            })
          });
          
          if (!res.ok) {
            throw new Error('Failed to add to cart');
          }
          
          const cart = await res.json();
          console.log('Added to cart:', cart);
          
          // 打开抽屉式购物车
          if (window.CartDrawer && window.CartDrawer.open) {
            window.CartDrawer.open();
          }
          
        } catch (error) {
          console.error('Error adding to cart:', error);
          alert('Error adding to cart: ' + error.message);
        } finally {
          this.disabled = false;
          this.textContent = 'ADD TO CART';
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const marqueeContainers = document.querySelectorAll('.testimonial-marquee');
    
    marqueeContainers.forEach(function(marqueeContainer) {
      const marqueeContent = marqueeContainer.querySelector('.marquee-content');
      
      if (marqueeContainer && marqueeContent) {
        const items = marqueeContent.querySelectorAll('.testimonial-item');
        
        if (items.length > 0) {
          const containerWidth = marqueeContainer.offsetWidth;
          const singleItemWidth = Array.from(items).reduce((total, item) => {
            const rect = item.getBoundingClientRect();
            const style = window.getComputedStyle(item);
            const marginRight = parseFloat(style.marginRight);
            return total + rect.width + marginRight;
          }, 0);
          
          const cloneCount = Math.max(10, Math.ceil((containerWidth * 2) / singleItemWidth));
          for (let i = 0; i < cloneCount; i++) {
            items.forEach(item => {
              const clone = item.cloneNode(true);
              marqueeContent.appendChild(clone);
            });
          }
          
          marqueeContent.offsetWidth;
          
          const originalItemsWidth = singleItemWidth;
          
          let position = 0;
          const speed = 60;
          let lastTime = performance.now();
          let animationId = null;
          
          function animate(currentTime) {
            const deltaTime = (currentTime - lastTime) / 1000;
            lastTime = currentTime;
            
            position -= speed * deltaTime;
            if (position <= -originalItemsWidth) {
              position = 0;
            }
            marqueeContent.style.transform = `translateX(${position}px)`;
            animationId = requestAnimationFrame(animate);
          }
          
          animationId = requestAnimationFrame(animate);
          
          marqueeContainer.addEventListener('mouseenter', () => {
            if (animationId) {
              cancelAnimationFrame(animationId);
              animationId = null;
            }
          });
          
          marqueeContainer.addEventListener('mouseleave', () => {
            lastTime = performance.now();
            animationId = requestAnimationFrame(animate);
          });
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trusted-media-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const marqueeContainer = document.querySelector('.media-marquee .marquee-container');
    const marqueeContent = document.querySelector('.media-marquee .marquee-content');
    
    if (marqueeContainer && marqueeContent) {
      const items = marqueeContent.querySelectorAll('.media-item');
      
      if (items.length > 0) {
        const containerWidth = marqueeContainer.offsetWidth;
        const singleItemWidth = Array.from(items).reduce((total, item) => total + item.offsetWidth, 0);
        
        const cloneCount = Math.max(10, Math.ceil((containerWidth * 2) / singleItemWidth));
        for (let i = 0; i < cloneCount; i++) {
          items.forEach(item => {
            const clone = item.cloneNode(true);
            marqueeContent.appendChild(clone);
          });
        }
        
        marqueeContent.offsetWidth;
        
        const originalItemsWidth = singleItemWidth;
        
        let position = 0;
        const speed = 50;
        let lastTime = performance.now();
        let animationId = null;
        
        function animate(currentTime) {
          const deltaTime = (currentTime - lastTime) / 1000;
          lastTime = currentTime;
          
          position -= speed * deltaTime;
          if (position <= -originalItemsWidth) {
            position = 0;
          }
          marqueeContent.style.transform = `translateX(${position}px)`;
          animationId = requestAnimationFrame(animate);
        }
        
        animationId = requestAnimationFrame(animate);
        
        marqueeContainer.addEventListener('mouseenter', () => {
          if (animationId) {
            cancelAnimationFrame(animationId);
            animationId = null;
          }
        });
        
        marqueeContainer.addEventListener('mouseleave', () => {
          lastTime = performance.now();
          animationId = requestAnimationFrame(animate);
        });
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["verify-code"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const urlParams = new URLSearchParams(window.location.search);
    const email = urlParams.get('email') || '';
    const redirect = urlParams.get('redirect') || '';
    
    const verificationForm = document.getElementById('verification-form');
    const verificationCodeInput = document.getElementById('verification_code');
    const resendButton = document.getElementById('resend-button');
    const continueButton = document.getElementById('continue-button');
    
    let isSubmitting = false;
    let isSendingCode = false;
    let countdown = 0;
    const COUNTDOWN_DURATION = 60;
    
    const updateHasValue = () => {
      if (verificationCodeInput.value.trim()) {
        verificationCodeInput.classList.add('has_value');
      } else {
        verificationCodeInput.classList.remove('has_value');
      }
    };
    
    verificationCodeInput.addEventListener('input', updateHasValue);
    verificationCodeInput.addEventListener('blur', updateHasValue);
    updateHasValue();
    
    const storageKey = `verification_code_sent_${email}`;
    const savedTimestamp = localStorage.getItem(storageKey);
    
    if (savedTimestamp) {
      const sentTime = parseInt(savedTimestamp, 10);
      const now = Date.now();
      const elapsed = Math.floor((now - sentTime) / 1000);
      const remaining = COUNTDOWN_DURATION - elapsed;
      
      if (remaining > 0) {
        countdown = remaining;
        updateResendButton();
        startCountdown();
      } else {
        localStorage.removeItem(storageKey);
      }
    }
    
    function updateResendButton() {
      if (countdown > 0 || isSendingCode) {
        resendButton.disabled = true;
        resendButton.style.opacity = '0.5';
        resendButton.style.cursor = 'not-allowed';
        if (isSendingCode) {
          resendButton.textContent = 'Sending...';
        } else {
          resendButton.textContent = `RESEND (${countdown}s)`;
        }
      } else {
        resendButton.disabled = false;
        resendButton.style.opacity = '1';
        resendButton.style.cursor = 'pointer';
        resendButton.textContent = 'RESEND';
      }
    }
    
    function startCountdown() {
      const timer = setInterval(() => {
        countdown--;
        updateResendButton();
        
        if (countdown <= 0) {
          clearInterval(timer);
          localStorage.removeItem(storageKey);
        }
      }, 1000);
    }
    
    resendButton.addEventListener('click', async function() {
      if (isSendingCode || countdown > 0) {
        return;
      }
      
      isSendingCode = true;
      updateResendButton();
      
      try {
        const response = await fetch('/apps/jarre-bull/api/email/send-code', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ email: email })
        });
        
        const data = await response.json();
        
        if (data.success) {
          const timestamp = Date.now();
          localStorage.setItem(storageKey, timestamp.toString());
          countdown = COUNTDOWN_DURATION;
          updateResendButton();
          startCountdown();
          alert('Verification code has been sent to your email');
        } else {
          alert(data.error || 'Failed to send verification code. Please try again.');
        }
      } catch (error) {
        console.error('Error sending verification code:', error);
        alert('Failed to send verification code. Please try again.');
      } finally {
        isSendingCode = false;
        updateResendButton();
      }
    });
    
    verificationForm.addEventListener('submit', async function(e) {
      e.preventDefault();
      
      if (isSubmitting) {
        return;
      }
      
      const verificationCode = verificationCodeInput.value.trim();
      
      if (!verificationCode) {
        alert('Please enter the verification code');
        return;
      }
      
      if (verificationCode.length !== 6) {
        alert('Please enter a valid 6-digit verification code');
        return;
      }
      
      isSubmitting = true;
      continueButton.disabled = true;
      continueButton.textContent = 'Verifying...';
      
      try {
        const response = await fetch('/apps/jarre-bull/api/email/verify-code', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ 
            email: email,
            code: verificationCode 
          })
        });
        
        const data = await response.json();
        
        if (data.success) {
          localStorage.setItem('email_verified', 'true');
          localStorage.setItem('verified_email', email);
          
          if (data.data && data.data.token) {
            localStorage.setItem('auth_token', data.data.token);
            localStorage.setItem('token_expires', data.data.expires_in_minutes);
          }
          
          alert('Verification successful!');
          
          let redirectUrl = '/cart';
          if (redirect === 'Order') {
            const savedOrderNumber = sessionStorage.getItem('order_tracking_orderNumber');
            const savedPaymentEmail = sessionStorage.getItem('order_tracking_paymentEmail');
            
            if (savedOrderNumber) {
              redirectUrl = `/pages/order?orderNumber=${encodeURIComponent(savedOrderNumber)}&paymentEmail=${encodeURIComponent(savedPaymentEmail || email)}`;
            } else {
              redirectUrl = '/pages/order';
            }
          }
          
          window.location.href = redirectUrl;
        } else {
          alert(data.error || 'Invalid verification code. Please try again.');
        }
      } catch (error) {
        console.error('Error verifying code:', error);
        alert('Invalid verification code. Please try again.');
      } finally {
        isSubmitting = false;
        continueButton.disabled = false;
        continueButton.textContent = 'CONTINUE';
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
